module.exports = __webpack_public_path__ + "img/winch_range.f7df05ca.jpg";